import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ChannelUpdateFragment = { id: string, name: string };


export type ChannelUpdateFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ChannelUpdateFragmentDoc = /*#__PURE__*/ gql`
    fragment ChannelUpdate on ChannelType {
  id
  name
}
    `;